import ResourceModal from 'app/components/ResourceModal';
import Form from 'app/components/Form';

import {
  getResourceLabel
} from 'app/resources';

const ColumnsModal = props => {
  const {
    isOpen,
    onClose,
    resource,
    columns
  } = props;

  const {
    columnDefs,
    toggleColumnDefs
  } = columns;

  const title = 'Columns';
  const resourceLabel = getResourceLabel(resource);
  const subTitle = `Toggle columns for ${resourceLabel} Grid`;
  const action = 'update';
  const loaded = true;

  // list the visible fields first, then sort the rest alphabetically.
  // remove action icons from list
  let visibleColDefs = columnDefs.filter(colDef => colDef.visible);
  let sortedColDefs = columnDefs.filter(colDef => !colDef.visible);
  sortedColDefs.sort((a, b) => {
    if (a.headerName.toLowerCase() < b.headerName.toLowerCase()) {
      return -1;
    }
  });
  sortedColDefs = visibleColDefs.concat(sortedColDefs)
    .filter(colDef => !colDef.actionIcon);

  let fields = [];
  for (let colDef of sortedColDefs) {
    const {
      actionIcon,
      field,
      headerName,
      visible
    } = colDef;

    fields.push({
      name: field,
      label: headerName,
      type: 'checkbox',
      valueType: 'boolean',
      value: visible
    });
  }

  const onSubmit = params => {
    // get array of visible field names
    let visibleFields = Object.keys(params).filter(field => params[field]);

    toggleColumnDefs(visibleFields);
  }

  return (
    <ResourceModal {...{ isOpen, onClose, title, subTitle }}>
      <Form {...{
	fields,
	action,
	onClose,
	onSubmit,
	loaded
      }} />
    </ResourceModal>
  );
}

export default ColumnsModal;
